
import { supabase } from '@/integrations/supabase/client';
import { SpotifyTrack, TrackDownload } from '@/lib/types';
import { uploadFileToStorage } from '../fileUploadUtils';

export async function saveTrackToDatabase(
  artistId: string,
  trackId: string,
  spotifyUrl: string,
  publicUrl: string,
  selectedFile: File,
  trackDetails: SpotifyTrack | null,
  description?: string
): Promise<TrackDownload | null> {
  try {
    // Make sure we have track details
    if (!trackDetails || !trackDetails.name || !trackDetails.artist) {
      console.error("Missing track details for database save", trackDetails);
      return null;
    }
    
    const fileExtension = selectedFile.name.split('.').pop() || 'unknown';
    
    // Log what we're about to insert into the database
    console.log("Saving track with details:", {
      artistName: trackDetails.artist,
      trackTitle: trackDetails.name,
      spotifyUrl: spotifyUrl,
      description: description
    });
    
    // Save track details to database - using original file name
    const { data: newTrack, error: insertError } = await supabase
      .from('tracks')
      .insert({
        artist_id: artistId,
        track_id: trackId,
        spotify_url: spotifyUrl,
        file_url: publicUrl,
        file_name: selectedFile.name, // Preserve original file name
        file_type: fileExtension,
        file_size: selectedFile.size,
        download_count: 0,
        artist_name: trackDetails.artist,
        track_title: trackDetails.name,
        description: description
      })
      .select()
      .single();
    
    if (insertError || !newTrack) {
      console.error("Database insert error:", insertError);
      throw new Error(insertError?.message || "Failed to save track");
    }
    
    console.log("Saved track to database successfully:", {
      artistName: newTrack.artist_name,
      trackTitle: newTrack.track_title
    });
    
    // Format for our UI
    const newUpload: TrackDownload = {
      id: newTrack.id,
      trackId: newTrack.track_id,
      spotifyUrl: newTrack.spotify_url,
      artistId: newTrack.artist_id,
      fileUrl: newTrack.file_url,
      fileName: newTrack.file_name,
      fileType: newTrack.file_type,
      fileSize: newTrack.file_size,
      downloadCount: newTrack.download_count,
      createdAt: newTrack.created_at,
      trackName: newTrack.track_title,
      artistName: newTrack.artist_name,
      description: newTrack.description
    };
    
    return newUpload;
  } catch (error) {
    console.error("Database save error:", error);
    return null;
  }
}
